module.exports = __webpack_public_path__ + "img/lock1.1bbcb8b5.svg";